import type { ReactNode } from 'react';
import { Group, Paper, Text, ThemeIcon } from '@mantine/core';
import type { StatusTone } from '../tokens/statusColorMap';
import { statusToneToMantineColor } from '../tokens/statusColorMap';

export interface SummaryFooterCardProps {
  label: string;
  value: string | number;
  icon?: ReactNode;
  tone?: StatusTone;
  wide?: boolean;
}

export function SummaryFooterCard({
  label,
  value,
  icon,
  tone = 'neutral',
  wide,
}: SummaryFooterCardProps) {
  const color = statusToneToMantineColor[tone];

  return (
    <Paper
      p="md"
      radius="lg"
      withBorder
      shadow="xs"
      style={wide ? { gridColumn: 'span 2' } : undefined}
    >
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <div>
          <Text size="xs" c="dimmed" tt="uppercase" fw={700}>{label}</Text>
          <Text size="lg" fw={800} mt={4}>{value}</Text>
        </div>
        {icon ? (
          <ThemeIcon size={36} radius="md" variant="light" color={color}>
            {icon}
          </ThemeIcon>
        ) : null}
      </Group>
    </Paper>
  );
}
